import { useUserMetaQuery } from 'queries/account';
import React, { createContext, useContext, ReactNode } from 'react';

interface UserMetaContextType {
  accountId: number;
  userId: number;
  isLoading: boolean;
}

const UserMetaContext = createContext<UserMetaContextType | undefined>(
  undefined,
);

interface UserMetaProviderProps {
  children: ReactNode;
}

export const UserMetaProvider: React.FC<UserMetaProviderProps> = ({
  children,
}) => {
  const { data: userData, isLoading } = useUserMetaQuery();
  const contextValue: UserMetaContextType = {
    accountId: userData?.accountId || 0,
    userId: userData?.userId || 0,
    isLoading,
  };

  return (
    <UserMetaContext.Provider value={contextValue}>
      {children}
    </UserMetaContext.Provider>
  );
};

export const useUserMeta = (): UserMetaContextType => {
  const context = useContext(UserMetaContext);

  if (context === undefined) {
    throw new Error('useUserMeta must be used within a UserMetaProvider');
  }

  return context;
};
